import { getOwaDatetimeStrings } from 'owa-strings/owa-datetime-strings';
import DayOfWeekType from '../../store/schema/DayOfWeekType';

export default function getLocalizedDayOfWeek(dayOfWeek: DayOfWeekType): string {
    return getOwaDatetimeStrings()['calendarDayOfWeek_' + dayOfWeek];
}
